import { both, converge, equals, identity } from 'ramda';

import isFinite from '../../isFinite';

var isIntegerPolyfill = /*#__PURE__*/both(isFinite, /*#__PURE__*/converge(equals, [Math.floor, identity]));

export default isIntegerPolyfill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/internal/polyfills/Number.isInteger.js
// module id = 749
// module chunks = 0